import { useEffect } from 'react'
import { Header } from '@components/layout/Header'
import { Footer } from '@components/layout/Footer'
import { useSmoothScroll } from '@hooks/useSmoothScroll'
import { useCustomCursor } from '@hooks/useCustomCursor'
import { Outlet, useLocation } from 'react-router-dom'

export function MainLayout() {
  const { pathname } = useLocation()
  
  useSmoothScroll();
  useCustomCursor();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return (
    <div className="min-h-screen flex flex-col bg-background-dark">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
